import { render, staticRenderFns } from "./OrticRole.vue?vue&type=template&id=6e64b0c2&"
import script from "./OrticRole.vue?vue&type=script&lang=js&"
export * from "./OrticRole.vue?vue&type=script&lang=js&"
import style0 from "./OrticRole.vue?vue&type=style&index=0&id=6e64b0c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports